/**
 * Used on a Filterrific form, using Turbostream
 *  * All form inputs will initiate a form submission when changed
 *  * Text input will allow a delay before form submission
 *
 * Accepts values:
 *  * (optional) text-input-delay - time delay (in ms) after text input changes to submit the form
 *
 * Use like so when creating a form:
 *
 *  = form_for_filterrific @filterrific,
 *      data: { controller: "forms--filterrific-form",
 *        forms__filterrific_form_text_input_delay_value: "1000"} do |f|
 *
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    textInputDelay: { type: Number, default: 500 },
  };

  get currentForm() {
    return this.element;
  }

  processResponse(xhr) {
    var rawResponse = xhr.response != null ? xhr.response : xhr.responseText,
      type = xhr.getResponseHeader("Content-Type"),
      response;

    if (typeof rawResponse === "string" && typeof type === "string") {
      Turbo.renderStreamMessage(rawResponse);
    }

    // Send after event
    this.currentForm.dispatchEvent(new Event("loadedFilterrificResults"));
  }

  processRequest() {
    const url = new URL(window.location.href);
    const formData = new FormData(this.currentForm);
    const filterParams = new URLSearchParams(formData);

    filterParams.forEach(function (v, k) {
      url.searchParams.set(k, v);
    });

    url.searchParams.set("page", 1);

    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
        var newUrl = new URL(url, window.location.origin);
        history.pushState({ turbo_stream: true }, document.title, newUrl);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  submitFilterForm() {
    // Send before event
    this.currentForm.dispatchEvent(new Event("loadingFilterrificResults"));

    // Submit Turbostream request
    this.processRequest();
  }

  reset() {
    this.currentForm.querySelectorAll("select").forEach((input) => {
      input.value = input.options[0].value;
    });
    this.currentForm.querySelectorAll("input, textarea").forEach((input) => {
      if (input.id.includes("filterrific")) {
        input.value = "";
      }
    });
    this.submitFilterForm();
  }

  connect() {
    // Add change event handler to all Filterrific filter inputs.
    if (this.currentForm) {
      this.currentForm.querySelectorAll("select").forEach((input) => {
        if (input.id.includes("filterrific")) {
          input.addEventListener("change", () => {
            this.submitFilterForm();
          });
        }
      });

      this.element.querySelectorAll("input, textarea").forEach((input) => {
        if (input.id.includes("filterrific")) {
          this.trigger = () => {
            if (this.timer) clearTimeout(this.timer);

            this.timer = setTimeout(() => {
              this.submitFilterForm();
            }, this.textInputDelayValue);
          };
          input.addEventListener("input", this.trigger, true);
        }
      });
    }
  }

  disconnect() {
    this.element.querySelectorAll("select").forEach((input) => {
      input.removeEventListener("change", () => {
        this.submitFilterForm();
      });
    });

    this.element.querySelectorAll("input, textarea").forEach((input) => {
      if (input.id.includes("filterrific")) {
        input.removeEventListener("input", this.trigger, true);
      }
    });
  }
}
